const ScrollMagic = require('scrollmagic')

class ZoomScrollElement {
    constructor(container) {
        let useZoomElementSelector = '.js__zoom-scroll-element'
        let duration = window.innerHeight / 3

        const image = container.querySelector(useZoomElementSelector)
        if (image && image.classList.contains('zoom-scroll-element__image')) {
            this.initializeScene(image, duration)
        } else {
            let supportsVideo = false
            // Get all source elements inside the video
            const sources = container.querySelector(useZoomElementSelector).getElementsByTagName('source')
            // Iterate over the sources and test to support video
            Array.from(sources).forEach((source) => {
                // Get the src attribute
                const src = source.getAttribute('src')
                if (src) {
                    // Use regex or split to extract the file extension
                    const fileExtension = src.split('.').pop()
                    if (this.supportsVideoType(fileExtension)) {
                        supportsVideo = true
                    }
                }
            })

            // if browser is not supporting webm
            if (!supportsVideo || !container.querySelector(useZoomElementSelector)) {
                const video = container.querySelector(useZoomElementSelector)

                if (video && video.classList.contains('zoom-scroll-element__image')) {
                    // do nothing when an image is used
                } else {
                    // remove video
                    if (video) video.remove()
                    // relate to background and no duration
                    useZoomElementSelector = '.js__zoom-scroll-background'
                    //show background
                    const background = container.querySelector(useZoomElementSelector)
                    background.style.setProperty('display', 'block')
                }
            }

            // initializeScene
            const elem = container.querySelector(useZoomElementSelector)
            if (elem) {
                this.initializeScene(elem, duration)
            }
        }
    }

    initializeScene = (elem, duration) => {
        elem.parentElement.style.setProperty('--duration', duration.toString())

        const controller = new ScrollMagic.Controller()

        new ScrollMagic.Scene({
            duration,
            triggerElement: elem.parentNode,
            offset: window.innerHeight / 2,
        })
            .on('progress', (event) => {
                elem.style.setProperty('--scroll', event.progress)
            })
            .addTo(controller)
    }

    supportsVideoType = (type) => {
        // Allow user to create shortcuts, i.e. just "webm"
        const formats = {
            ogg: 'video/ogg; codecs="theora"',
            mp4: 'video/mp4; codecs="avc1.42E01E"',
            webm: 'video/webm; codecs="vp8, vorbis"',
            mpeg: 'application/x-mpegURL; codecs="avc1.42E01E"',
        }

        const video = document.createElement('video')
        return video.canPlayType(formats[type] || type)
    }
}

function initZoomScrollElement() {
    const animateElem = document.querySelectorAll('.js__zoom-scroll-container')
    animateElem.forEach((elem) => {
        new ZoomScrollElement(elem)
    })
}

if (document.readyState !== 'loading') {
    initZoomScrollElement()
} else {
    document.addEventListener('DOMContentLoaded', initZoomScrollElement)
}
